"use client"

import { useEffect, useState } from "react"

import { usePathname } from "next/navigation"

import { PartnerCampaign, readPartnerCampaign } from "./campaign"

export const usePartnerCampaign = () => {
  const pathname = usePathname()
  const [campaign, setCampaign] = useState<PartnerCampaign | null>(null)

  useEffect(() => {
    let attempts = 0

    const syncCampaign = () => {
      const nextCampaign = readPartnerCampaign()
      setCampaign(nextCampaign)

      if (nextCampaign || attempts >= 20) {
        return true
      }

      attempts += 1
      return false
    }

    if (syncCampaign()) {
      return
    }

    const intervalId = window.setInterval(() => {
      if (syncCampaign()) {
        window.clearInterval(intervalId)
      }
    }, 250)

    return () => {
      window.clearInterval(intervalId)
    }
  }, [pathname])

  return campaign
}
